
  export default {
    name: 'bottomFooter',
    props: {
      skinny: {
        type:Boolean,
        default:null
      },
      env: {

      }
    },

  }
